import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IAuthUsersService } from "services/AuthUsersService";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import * as auth from "app/modules/auth";
import { RootState } from "setup";

const initialState = {
  EmailVerificationResponse: false,
  VerifyingEmail: false,
};

export const emailVerificationSlice = createSlice({
  name: "emailVerification",
  initialState,
  reducers: {
    setResult: (state, action) => {
      state.EmailVerificationResponse = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyEmail.pending, (state) => {
        state.VerifyingEmail = true;
      })
      .addCase(verifyEmail.rejected, (state) => {
        state.VerifyingEmail = false;
      })
      .addCase(verifyEmail.fulfilled, (state) => {
        state.EmailVerificationResponse = true;
        state.VerifyingEmail = false;
      });
  },
});

export const verifyEmail = createAsyncThunk(
  "emailVerification/verifyEmail",
  async ({ userID, verificationCode }: { userID: string; verificationCode: string }, thunkAPI) => {
    const usersService = container.get<IAuthUsersService>(SERVICE_TYPES.AuthUsersService);
    const emailVerificationResponse = await usersService.verifyEmail(userID, verificationCode);
    thunkAPI.dispatch(auth.actions.requestUser);
    return emailVerificationResponse;
  }
);

export const resendVerificationEmail = createAsyncThunk(
  "emailVerification/resendVerificationEmail",
  async ({ userID }: { userID: string }) => {
    const usersService = container.get<IAuthUsersService>(SERVICE_TYPES.AuthUsersService);
    return await usersService.resendVerificationEmail(userID);
  }
);

export const { setResult } = emailVerificationSlice.actions;

export const selectEmailVerificationResponse = (state: RootState) => {
  return state.validateEmail.EmailVerificationResponse;
};
export const selectVerifyingEmail = (state: RootState) => {
  return state.validateEmail.VerifyingEmail;
};

export default emailVerificationSlice.reducer;
